import React from 'react';

const BookingHeader = ({ clinicSettings, loading = false }) => {
  if (loading) {
    return (
      <div className="bg-white border-b border-gray-200 px-4 py-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-gray-200 rounded-lg animate-pulse"></div>
              <div>
                <div className="h-6 bg-gray-200 rounded w-48 animate-pulse mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
              </div>
            </div>
            <div className="mt-4 md:mt-0 md:text-right">
              <div className="h-4 bg-gray-200 rounded w-40 animate-pulse mb-2"></div>
              <div className="h-4 bg-gray-200 rounded w-32 animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!clinicSettings) {
    return null;
  }

  const {
    clinicName,
    logo,
    address,
    contactPhone,
    contactEmail,
    openingHours,
    businessHours
  } = clinicSettings;

  // Generate opening hours string from businessHours if openingHours not provided
  const getOpeningHoursString = () => {
    if (openingHours) return openingHours;
    
    if (!businessHours) return "Contact clinic for hours";
    
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    
    const openDays = [];
    days.forEach((day, index) => {
      const dayHours = businessHours[day];
      if (dayHours && !dayHours.closed) {
        openDays.push(`${dayNames[index]} ${dayHours.open}-${dayHours.close}`);
      }
    });
    
    return openDays.length > 0 ? openDays.join(', ') : "Contact clinic for hours";
  };

  return (
    <div className="bg-white border-b border-gray-200 px-4 py-6 sticky top-0 z-10 shadow-sm">
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          {/* Left side - Logo and clinic name */}
          <div className="flex items-center space-x-4">
            {logo && (
              <img 
                src={logo} 
                alt={`${clinicName} logo`}
                className="w-16 h-16 object-contain rounded-lg border border-gray-200"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            )}
            <div>
              <h1 className="text-2xl font-bold text-gray-900">{clinicName}</h1>
              <p className="text-sm text-gray-600">{getOpeningHoursString()}</p>
            </div>
          </div>

          {/* Right side - Contact info */}
          <div className="mt-4 md:mt-0 md:text-right space-y-1">
            {address && (
              <p className="text-sm text-gray-600">{address}</p>
            )}
            <div className="flex flex-col md:items-end space-y-1">
              {contactPhone && (
                <a 
                  href={`tel:${contactPhone}`}
                  className="text-sm text-blue-600 hover:text-blue-800 transition-colors"
                >
                  {contactPhone}
                </a>
              )}
              {contactEmail && (
                <a 
                  href={`mailto:${contactEmail}`}
                  className="text-sm text-blue-600 hover:text-blue-800 transition-colors"
                >
                  {contactEmail}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingHeader;
